import React from 'react';
import { localeStrings as strings } from 'applicationConfig';

import footerMenuData from './footerMenuData';

import { Link } from 'react-router-dom';

const ShellFooter = (props) => {
  const currentYear = new Date().getFullYear();
  const _generateServiceGroups = function(data) {
    return (
      <div className="service-wrap">
        {data.map((group, key) => {
          return (
            <div className="service-group" key={`service-group-${key}`}>
              <ul>
                <li className="service-group-header">
                  <p>
                    <b>{group.title}</b>
                  </p>
                </li>
                {group.items.map((item, key) => {
                  return (
                    <li key={`service-item-${key}`}>
                      {0 === (item.url || '').indexOf('http') ? (
                        <a href={item.url} target="_blank" className="service-item" rel="noopener noreferrer">
                          {item.text}
                        </a>
                      ) : (
                        <Link to={item.url || '/help/under-construction'} className="service-item">
                          {item.text}
                        </Link>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="footer-container">
      <div className="shell-footer">
        <div>
          <div className="fix-widthed">
            <span>{strings.footerLinks.moreInfoLable}</span>
            <a
              href={strings.footerLinks.ourBusinesses}
              target="_blank"
              className="service-item"
              rel="noopener noreferrer"
            >
              <b>{strings.footerLinks.clickHere}</b>
            </a>
          </div>
        </div>
        <div className="fix-widthed">{_generateServiceGroups(footerMenuData)}</div>
        <div className="fix-widthed delivered-by">
          <span>{strings.footerLinks.deliveredBy} </span>
          <a href={strings.footerLinks.infoURL} target="_blank" className="service-item" rel="noopener noreferrer">
            <b>{strings.footerLinks.otherSites.links.tulletPrebonInfo}</b>
          </a>
        </div>
      </div>
      <div className="copyright">
        <div className="fix-widthed">
          <div className="copyright-info">
            <div>
              <span>{strings.footerLinks.copyright}</span>
              <span>&copy; {currentYear} </span>
              <span>{strings.footerLinks.tpicap}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShellFooter;



// WEBPACK FOOTER //
// ./src/containers/layouts/MainLayout/ShellFooter.jsx